import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

interface WorkflowSettings {
    tech_can_create_estimates: boolean;
    tech_can_create_invoices: boolean;
    tech_can_view_pricing: boolean;
    tech_can_schedule_jobs: boolean;
    tech_can_book_jobs: boolean;
    office_approves_before_send: boolean;
    auto_invoice_on_complete: boolean;
    auto_create_estimate_on_fail: boolean;
    require_photo_on_complete: boolean;
    require_signature_on_complete: boolean;
}

const DEFAULTS: WorkflowSettings = {
    tech_can_create_estimates: false,
    tech_can_create_invoices: false,
    tech_can_view_pricing: false,
    tech_can_schedule_jobs: false,
    tech_can_book_jobs: false,
    office_approves_before_send: true,
    auto_invoice_on_complete: true,
    auto_create_estimate_on_fail: true,
    require_photo_on_complete: false,
    require_signature_on_complete: false,
};

export function useWorkflow() {
    const { data, isLoading } = useQuery({
        queryKey: ["settings", "workflow"],
        queryFn: () => api.get<{ workflow: Record<string, unknown> }>("/api/settings/workflow"),
        staleTime: 60_000,
    });

    const raw = data?.workflow ?? {};
    const workflow: WorkflowSettings = { ...DEFAULTS };
    for (const key of Object.keys(DEFAULTS) as Array<keyof WorkflowSettings>) {
        if (key in raw) {
            workflow[key] = raw[key] === true || raw[key] === "true";
        }
    }

    return { workflow, isLoading };
}
